export default __webpack_public_path__ + "static/media/C1.cd1d83dc.png";